/** Typical session time as medians, so one survey left open overnight cannot skew it. */

export interface TimedSession {
  time_spent_seconds: number | null;
  active_time_seconds?: number | null;
}

export interface SessionTimeStats {
  medianActiveSeconds: number | null;
  medianTotalSeconds: number | null;
}

export function median(values: number[]): number | null {
  if (values.length === 0) return null;
  const sorted = [...values].sort((a, b) => a - b);
  const mid = Math.floor(sorted.length / 2);
  const value = sorted.length % 2 === 1 ? sorted[mid] : (sorted[mid - 1] + sorted[mid]) / 2;
  return Math.round(value);
}

const isMeasured = (seconds: number | null | undefined): seconds is number => seconds != null;

// A session with no timing is left out of that median, never counted as 0.
export function summarizeSessionTimes(sessions: TimedSession[]): SessionTimeStats {
  return {
    medianActiveSeconds: median(sessions.map((s) => s.active_time_seconds).filter(isMeasured)),
    medianTotalSeconds: median(sessions.map((s) => s.time_spent_seconds).filter(isMeasured)),
  };
}
